export enum ProjectApiErrorTypes {
  LoadProjectError,
  LoadProjectsError,
  LoadProjectSummaryError,
  CreateProjectError,
  DuplicatedProjectError,
  UpdateProjectError,
  DeleteProjectError,
  ProjectNotFoundError,
}
export class ProjectApiError {
  constructor(public type: ProjectApiErrorTypes, public error: Error) {}
}

export enum ProjectGenericErrorTypes {
  ShowDeployProjectConfirmError,
  ShowDeleteProjectConfirmError,
  ShowDuplicateProjectDialogError,
}
export class ProjectGenericError {
  constructor(public type: ProjectGenericErrorTypes, public error: Error) {}
}
